import React from "react";

export default function Error() {
  return <div>wat r u doing??</div>;
}
